import { Button, type SxProps, type Theme } from '@mui/material';
import clsx from 'clsx';

import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';

import useBrainSession from '../../services/BrainSession/useBrainSession.ts';

export interface ActionButtonProps {
  children?: React.ReactNode;
  label?: string;
  flow?: string;
  step?: string;
  clientKnowledge?: Record<string, any>;
  color?: 'secondary' | 'primary' | 'transparent';
  gaEvent?: string;
  gaParameters?: Record<string, any>;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  onClick?: () => void;
  labelClassName?: string;
  [key: string]: any;
  sx?: SxProps<Theme>;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  children = null,
  label,
  flow,
  step,
  clientKnowledge = {},
  color = 'secondary',
  gaEvent,
  gaParameters = {},
  className,
  size = 'large',
  onClick,
  labelClassName,
  ...props
}) => {
  const { toggleChat } = useBrainSession();

  return (
    <Button
      variant="contained"
      size={size}
      className={className}
      color={color === 'transparent' ? 'inherit' : color}
      onClick={() => {
        if (gaEvent) {
          sendUserPortalEvent(gaEvent, gaParameters);
        }
        if (onClick) {
          onClick();
          return;
        }
        toggleChat({
          goal: flow,
          step,
          clientKnowledge,
        });
      }}
      {...props}
    >
      <p
        className={clsx(
          'mb-0! flex w-full items-center justify-center typography-v1-button2',
          labelClassName,
        )}
      >
        <span dangerouslySetInnerHTML={{ __html: label || '' }} /> {children}
      </p>
    </Button>
  );
};

export default ActionButton;
